import React from 'react'
import Link from '@react/react-spectrum/Link'
import analytics from '../../config/analytics'

export default function NavLink ({ className, label, url, referrer, noBreak }) {
    if (noBreak) {
        return (
            <Link className={className} onClick={ e => analytics.sendEventName('link', referrer) } target='_blank' href={url}>{label}</Link>
        )
    }
    return (
        <div>
            <Link className={className} onClick={ e => analytics.sendEventName('link', referrer) } target='_blank' href={url}>{label}</Link>
        </div>
    )
}
